import { useParams } from 'react-router';
import { useQuery } from '@apollo/client/react';

import { CUSTOMER_PREFERENCES } from 'queries/customer';

// Hook that returns a boolean whether we are allowed to communicate (email, calls, text) with this customer or not
// returns null initially until the CUSTOMER_PREFERENCES query resolves. Then returns true or false.
const useCeaseAndDesistStatus = () => {
  const { customerId } = useParams();

  const ceaseAndDesistQuery = useQuery(CUSTOMER_PREFERENCES, {
    variables: { customerId },
    fetchPolicy: 'cache-and-network',
    notifyOnNetworkStatusChange: true,
  });

  const ceaseAndDesist =
    ceaseAndDesistQuery.data?.customer?.communicationPreferences?.ceaseDesist;

  return {
    ceaseAndDesist,
    ceaseAndDesistEnabled: !!ceaseAndDesist,
    ceaseAndDesistQuery,
  };
};

export default useCeaseAndDesistStatus;
